import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import { Button, TextField } from "@mui/material";

import Select from "react-select";

import Loader from "../../components/Loader";
import Toast from "../../utils/Toast";
import Swal from "sweetalert2";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AuthContext } from "../../utils/userProvider";
import useSystemSetting from "../../queries/system/getSystemSettings";
import editSystemSettings from "../../mutation/system/editSystemSettings";
import useBookingSources from "../../queries/system/getBookingSources";
import useSundries from "../../queries/system/getSundries";
import updateResTypes from "../../queries/system/updateResTypes";
import useResTypes from "../../queries/system/getResTypes";
import parseBookingSources from "../../utils/parseBookingSources";
import parseResTypes from "../../utils/parseResTypes";
import initializeWebhooks from "../../mutation/system/initializeWebhook";
import refreshAvailability from "../../mutation/system/refreshAvailability";

import parseRequirements from "../../utils/parseRequirements";
import useRequirements from "../../queries/addon/requirements";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
} from "../../components/ListPage";
/* import useChangePassword from "../../mutation/changePassword/changePassword"; */

const schema = yup.object().shape({
  nudgify_uuid_english: yup.string(),
  nudgify_key_english: yup.string(),
  nudgify_uuid_chinese: yup.string(),
  nudgify_key_chinese: yup.string(),
});

const SystemSettings = () => {
  const { authState, setAuthState } = useContext(AuthContext);
  let [systemResponse, reset] = useSystemSetting();
  let [bookingSourceResponse, resetBookingSource] = useBookingSources();
  let [sundryResponse, resetSundryResponse] = useSundries();
  const [requirementsResponse, resetRequirements] = useRequirements();
  const [resTypes, setResTypes] = useResTypes();
  const [requirementOptions, setRequirementOptions] = useState(null);
  //let [passwordResponse, setData] = useChangePassword();

  let [emailInterval, setEmailInterval] = useState(null);
  let [expiryDuration, setExpiryDuration] = useState(null);

  let [referralRebateAmountShort, setReferralRebateAmountShort] =
    useState(null);
  let [referralRebateAmountHalf, setReferralRebateAmountHalf] = useState(null);
  let [referralRebateAmountFull, setReferralRebateAmountFull] = useState(null);
  let [referrerRebateAmountShort, setReferrerRebateAmountShort] =
    useState(null);
  let [referrerRebateAmountHalf, setReferrerRebateAmountHalf] = useState(null);
  let [referrerRebateAmountFull, setReferrerRebateAmountFull] = useState(null);
  let [officeBankChargesID, setOfficeBankChargesID] = useState(null);
  let [flywireChargesID, setFlywireChargesID] = useState(null);
  let [agentBookingSource, setAgentBookingSource] = useState(null);
  let [sharerBookingSource, setSharerBookingSource] = useState(null);
  let [agentSharerBookingSource, setAgentSharerBookingSource] = useState(null);
  let [sharerRequirementId, setSharerRequirementId] = useState(null);
  let [agentGuardianBookingSource, setAgentGuardianBookingSource] =
    useState(null);
  let [guardianBookingSource, setGuardianBookingSource] = useState(null);
  let [agentAbandonCartEmail, setAgentAbandonCartEmail] = useState(null);

  let [flywireUnsupportedCountries, setFlyWireUnsupportedCountries] = useState(null);
  let [flywireSupportedCountries, setFlyWireSupportedCountries] = useState(null);
  let [flywireSupportedCountriesWithFee, setFlyWireSupportedCountriesWithFee] = useState(null);
  let [flywireSupportedCountriesWithInvoice, setFlyWireSupportedCountriesWithInvoice] = useState(null);

  let [bookingSourceOptions, setBookingSourceOptions] = useState(null);
  let [sundryOptions, setSundryOptions] = useState(null);
  let [resTypesSource, setResTypesSource] = useState(null);
  let [resTypesSourceOptions, setResTypesSourceOptions] = useState(null);

  let [defaultUUIDEng, setDefaultUUIDEng] = useState(null);
  let [defaultKeyEng, setDefaultKeyEng] = useState(null);
  let [defaultUUIDChi, setDefaultUUIDChi] = useState(null);
  let [defaultKeyChi, setDefaultKeyChi] = useState(null);
  let [set2Month, setSet2Month] = useState(null);

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const intervalOptions = [
    {
      label: "12",
      value: 12,
    },
    {
      label: "24",
      value: 24,
    },
    {
      label: "36",
      value: 36,
    },
    {
      label: "48",
      value: 48,
    },
    {
      label: "60",
      value: 60,
    },
    {
      label: "72",
      value: 72,
    },
  ];

  const expiryOptions = [
    {
      label: "1",
      value: 1,
    },
    {
      label: "2",
      value: 2,
    },
    {
      label: "3",
      value: 3,
    },
    {
      label: "4",
      value: 4,
    },
    {
      label: "5",
      value: 5,
    },
    {
      label: "6",
      value: 6,
    },
    {
      label: "7",
      value: 7,
    },
    {
      label: "8",
      value: 8,
    },
    {
      label: "9",
      value: 9,
    },
    {
      label: "10",
      value: 10,
    },
  ];

  const monthOptions = [
    { label: "None", value: null },
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  const refreshCache = async (force = false) => {
    Swal.fire({
      title: "Refreshing Availability Cache",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      showConfirmButton: false,
      willOpen: async () => {
        Swal.showLoading();
        try {
          let response = await refreshAvailability(authState.jwt, {
            force: force,
          });
          if (response.data === "success") {
            Toast.fire({
              icon: "success",
              title:
                "Cache is being refreshed. Please wait around 20 minutes for caching to complete",
            });
          }
        } catch (err) {
          console.log(err);
          if (err?.errorMessage?.message?.message === "processing") {
            Swal.fire({
              icon: "error",
              titleText: "In Processing",
              text: "Cache is still in the midst of processing. Would you like to restart the caching process?",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCloseButton: true,
              showCancelButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                refreshCache(true);
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              titleText: "Error",
              text: "An Error has occured. Please try again.",
              allowOutsideClick: true,
              allowEscapeKey: true,
            });
          }
        }
      },
    });
  };

  useEffect(() => {
    if (
      systemResponse.data &&
      bookingSourceResponse.data &&
      requirementsResponse.data &&
      sundryResponse.data
    ) {
      if (systemResponse.data.email_interval) {
        setEmailInterval({
          label: systemResponse.data.email_interval,
          value: systemResponse.data.email_interval,
        });
      }
      if (systemResponse.data.expiry_duration) {
        setExpiryDuration({
          label: systemResponse.data.expiry_duration,
          value: systemResponse.data.expiry_duration,
        });
      }
      if (systemResponse.data.agent_abandon_cart_email != null) {
        setAgentAbandonCartEmail({
          label: systemResponse.data.agent_abandon_cart_email,
          value: systemResponse.data.agent_abandon_cart_email,
        });
      } else {
        setAgentAbandonCartEmail({
          label: "",
          value: "",
        });
      }

      if (systemResponse.data.flywire_unsupported_countries != null) {
        setFlyWireUnsupportedCountries({
          label: systemResponse.data.flywire_unsupported_countries,
          value: systemResponse.data.flywire_unsupported_countries,
        });
      } else {
        setFlyWireUnsupportedCountries({
          label: "",
          value: "",
        });
      }
      if (systemResponse.data.flywire_supported_countries != null) {
        setFlyWireSupportedCountries({
          label: systemResponse.data.flywire_supported_countries,
          value: systemResponse.data.flywire_supported_countries,
        });
      } else {
        setFlyWireSupportedCountries({
          label: "",
          value: "",
        });
      }
      if (systemResponse.data.flywire_supported_countries_with_fee != null) {
        setFlyWireSupportedCountriesWithFee({
          label: systemResponse.data.flywire_supported_countries_with_fee,
          value: systemResponse.data.flywire_supported_countries_with_fee,
        });
      } else {
        setFlyWireSupportedCountriesWithFee({
          label: "",
          value: "",
        });
      }
      if (systemResponse.data.flywire_supported_countries_with_invoice != null) {
        setFlyWireSupportedCountriesWithInvoice({
          label: systemResponse.data.flywire_supported_countries_with_invoice,
          value: systemResponse.data.flywire_supported_countries_with_invoice,
        });
      } else {
        setFlyWireSupportedCountriesWithInvoice({
          label: "",
          value: "",
        });
      }

      console.log(systemResponse.data.referral_rebate_amount_short);
      if (systemResponse.data.referral_rebate_amount_short != null) {
        setReferralRebateAmountShort({
          label: systemResponse.data.referral_rebate_amount_short,
          value: systemResponse.data.referral_rebate_amount_short,
        });
      }
      if (systemResponse.data.referral_rebate_amount_half != null) {
        setReferralRebateAmountHalf({
          label: systemResponse.data.referral_rebate_amount_half,
          value: systemResponse.data.referral_rebate_amount_half,
        });
      }
      if (systemResponse.data.referral_rebate_amount_full != null) {
        setReferralRebateAmountFull({
          label: systemResponse.data.referral_rebate_amount_full,
          value: systemResponse.data.referral_rebate_amount_full,
        });
      }
      if (systemResponse.data.referrer_rebate_amount_short != null) {
        setReferrerRebateAmountShort({
          label: systemResponse.data.referrer_rebate_amount_short,
          value: systemResponse.data.referrer_rebate_amount_short,
        });
      }
      if (systemResponse.data.referrer_rebate_amount_half != null) {
        setReferrerRebateAmountHalf({
          label: systemResponse.data.referrer_rebate_amount_half,
          value: systemResponse.data.referrer_rebate_amount_half,
        });
      }
      if (systemResponse.data.referrer_rebate_amount_full != null) {
        setReferrerRebateAmountFull({
          label: systemResponse.data.referrer_rebate_amount_full,
          value: systemResponse.data.referrer_rebate_amount_full,
        });
      }
      if (sundryResponse.data) {
        let sundryOptions = parseBookingSources(sundryResponse.data);
        setSundryOptions(sundryOptions);
      }
      if (systemResponse.data.office_bank_charges_id) {
        let defaultValue = sundryResponse.data.find(
          (ele) => systemResponse.data.office_bank_charges_id == ele.id
        );
        if (defaultValue) {
          setOfficeBankChargesID({
            label: defaultValue.name + " (" + defaultValue.id + ")",
            value: defaultValue.id,
          });
        }
      }
      if (systemResponse.data.flywire_charges_id) {
        let defaultValue = sundryResponse.data.find(
          (ele) => systemResponse.data.office_bank_charges_id == ele.id
        );
        if (defaultValue) {
          setFlywireChargesID({
            label: defaultValue.name + " (" + defaultValue.id + ")",
            value: defaultValue.id,
          });
        }
      }
      if (bookingSourceResponse.data) {
        let bookingSourceOptions = parseBookingSources(
          bookingSourceResponse.data
        );
        setBookingSourceOptions(bookingSourceOptions);
      }
      if (systemResponse.data.agent_booking_source_id) {
        let defaultValue = bookingSourceResponse.data.find(
          (ele) => systemResponse.data.agent_booking_source_id == ele.id
        );
        setAgentBookingSource({
          label: defaultValue.name + " (" + defaultValue.id + ")",
          value: defaultValue.id,
        });
      }
      if (systemResponse.data.sharer_booking_source_id) {
        let defaultValue = bookingSourceResponse.data.find(
          (ele) => systemResponse.data.sharer_booking_source_id == ele.id
        );
        setSharerBookingSource({
          label: defaultValue.name + " (" + defaultValue.id + ")",
          value: defaultValue.id,
        });
      }
      if (systemResponse.data.agent_sharer_booking_source_id) {
        let defaultValue = bookingSourceResponse.data.find(
          (ele) => systemResponse.data.agent_sharer_booking_source_id == ele.id
        );
        setAgentSharerBookingSource({
          label: defaultValue.name + " (" + defaultValue.id + ")",
          value: defaultValue.id,
        });
      }
      if (requirementsResponse.data) {
        let requirements = requirementsResponse.data.requirements;
        let parsedRequirements = parseRequirements(requirements);
        if (requirements && requirements.length > 0) {
          setRequirementOptions(parsedRequirements);
        }
        console.log("PARSEDREQqq");
        console.log(parsedRequirements);
      }
      if (
        requirementsResponse.data &&
        systemResponse.data.sharer_requirement_id
      ) {
        if (systemResponse.data.sharer_requirement_id) {
          let requirements = requirementsResponse.data.requirements;
          let parsedRequirements = parseRequirements(requirements);
          console.log(systemResponse.data.sharer_requirement_id);
          let requirementName = parsedRequirements.find((element) => {
            return element.value == systemResponse.data.sharer_requirement_id;
          }).label;
          let defaultValue = {
            label: requirementName,
            value: systemResponse.data.sharer_requirement_id,
          };
          setSharerRequirementId(defaultValue);
        }
      }
      if (
        requirementsResponse.data &&
        systemResponse.data.agent_guardian_booking_source_id
      ) {
        let defaultValue = bookingSourceResponse.data.find(
          (ele) =>
            systemResponse.data.agent_guardian_booking_source_id == ele.id
        );
        setAgentGuardianBookingSource({
          label: defaultValue.name + " (" + defaultValue.id + ")",
          value: defaultValue.id,
        });
      }
      if (
        requirementsResponse.data &&
        systemResponse.data.guardian_booking_source_id
      ) {
        let defaultValue = bookingSourceResponse.data.find(
          (ele) => systemResponse.data.guardian_booking_source_id == ele.id
        );
        setGuardianBookingSource({
          label: defaultValue.name + " (" + defaultValue.id + ")",
          value: defaultValue.id,
        });
      }

      if (resTypes.data) {
        console.log(resTypes.data);
        setResTypesSourceOptions(parseResTypes(resTypes.data));
      }

      if (resTypes.data && systemResponse.data.res_types_source_id) {
        let defaultValue = resTypes.data.find(
          (ele) => systemResponse.data.res_types_source_id == ele.id
        );

        setResTypesSource({
          label: defaultValue.name + " (" + defaultValue.id + ")",
          value: defaultValue.id,
        });
      }
      console.log("uuidEng: ", systemResponse.data.nudgify_uuid_english);
      if (systemResponse.data.nudgify_uuid_english) {
        setDefaultUUIDEng(systemResponse.data.nudgify_uuid_english);
        setValue(
          "nudgify_uuid_english",
          systemResponse.data.nudgify_uuid_english
        );
      } else {
        console.log("else");
        setDefaultUUIDEng("");
        setValue("nudgify_uuid_english", "");
      }
      if (systemResponse.data.nudgify_key_english) {
        setDefaultKeyEng(systemResponse.data.nudgify_key_english);
        setValue(
          "nudgify_key_english",
          systemResponse.data.nudgify_key_english
        );
      } else {
        setDefaultKeyEng("");
        setValue("nudgify_key_english", "");
      }
      if (systemResponse.data.nudgify_uuid_chinese) {
        setDefaultUUIDChi(systemResponse.data.nudgify_uuid_chinese);
        setValue(
          "nudgify_uuid_chinese",
          systemResponse.data.nudgify_uuid_chinese
        );
      } else {
        setDefaultUUIDChi("");
        setValue("nudgify_uuid_chinese", "");
      }
      if (systemResponse.data.nudgify_key_chinese) {
        setDefaultKeyChi(systemResponse.data.nudgify_key_chinese);
        setValue(
          "nudgify_key_chinese",
          systemResponse.data.nudgify_key_chinese
        );
      } else {
        setDefaultKeyChi("");
        setValue("nudgify_key_chinese", "");
      }

      // Load Set2 month setting
      if (systemResponse.data.set2_month && Array.isArray(systemResponse.data.set2_month) && systemResponse.data.set2_month.length > 0) {
        const selectedMonths = monthOptions.filter(option =>
          systemResponse.data.set2_month.includes(option.value)
        );
        setSet2Month(selectedMonths);
      } else {
        setSet2Month([]);
      }
    }
  }, [
    systemResponse,
    bookingSourceResponse,
    requirementsResponse,
    resTypes,
    sundryResponse,
  ]);
  const emailIntervalChange = (result) => {
    let updateObject = {
      email_interval: result.value,
    };

    runUpdate(updateObject);
  };

  const expiryDurationChange = (result) => {
    let updateObject = {
      expiry_duration: result.value,
    };

    runUpdate(updateObject);
  };


  const agentAbandonCartEmailOnchange = (result) => {
    setAgentAbandonCartEmail({
      label: result.target.value,
      value: result.target.value,
    });
  };

  const agentAbandonCartEmailUpdate = (result) => {
    let updateObject = {
      agent_abandon_cart_email: result.target.value,
    };

    runUpdate(updateObject);
  };

  const flywireUnsupportedCountriesOnchange = (result) => {
    setFlyWireUnsupportedCountries({
      label: result.target.value,
      value: result.target.value,
    });
  };

  const flywireUnsupportedCountriesUpdate = (result) => {
    let updateObject = {
      flywire_unsupported_countries: result.target.value,
    };

    runUpdate(updateObject);
  };

  const flywireSupportedCountriesOnchange = (result) => {
    setFlyWireSupportedCountries({
      label: result.target.value,
      value: result.target.value,
    });
  };

  const flywireSupportedCountriesUpdate = (result) => {
    let updateObject = {
      flywire_supported_countries: result.target.value,
    };

    runUpdate(updateObject);
  };

  const flywireSupportedCountriesWithFeeOnchange = (result) => {
    setFlyWireSupportedCountriesWithFee({
      label: result.target.value,
      value: result.target.value,
    });
  };

  const flywireSupportedCountriesWithFeeUpdate = (result) => {
    let updateObject = {
      flywire_supported_countries_with_fee: result.target.value,
    };

    runUpdate(updateObject);
  };

  const flywireSupportedCountriesWithInvoiceOnchange = (result) => {
    setFlyWireSupportedCountriesWithInvoice({
      label: result.target.value,
      value: result.target.value,
    });
  };

  const flywireSupportedCountriesWithInvoiceUpdate = (result) => {
    let updateObject = {
      flywire_supported_countries_with_invoice: result.target.value,
    };

    runUpdate(updateObject);
  };

  const set2MonthChange = (selectedOptions) => {
    setSet2Month(selectedOptions || []);
    const monthValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
  
    let updateObject = {
      set2_month: monthValues,
    };

    runUpdate(updateObject);
  };

  const referralRebateAmountShortOnchange = (result) => {
    if (!isNaN(parseInt(result.target.value))) {
      setReferralRebateAmountShort({
        label: result.target.value,
        value: result.target.value,
      });
    }
  };

  const referralRebateAmountHalfOnchange = (result) => {
    if (!isNaN(parseInt(result.target.value))) {
      setReferralRebateAmountHalf({
        label: result.target.value,
        value: result.target.value,
      });
    }
  };

  const referralRebateAmountFullOnchange = (result) => {
    if (!isNaN(parseInt(result.target.value))) {
      setReferralRebateAmountFull({
        label: result.target.value,
        value: result.target.value,
      });
    }
  };
  const referrerRebateAmountShortOnchange = (result) => {
    if (!isNaN(parseInt(result.target.value))) {
      setReferrerRebateAmountShort({
        label: result.target.value,
        value: result.target.value,
      });
    }
  };

  const referrerRebateAmountHalfOnchange = (result) => {
    if (!isNaN(parseInt(result.target.value))) {
      setReferrerRebateAmountHalf({
        label: result.target.value,
        value: result.target.value,
      });
    }
  };

  const referrerRebateAmountFullOnchange = (result) => {
    if (!isNaN(parseInt(result.target.value))) {
      setReferrerRebateAmountFull({
        label: result.target.value,
        value: result.target.value,
      });
    }
  };

  const officeBankChargesIDChange = (result) => {
    let updateObject = {
      office_bank_charges_id: result.value,
    };

    runUpdate(updateObject);
  };

  const flywireChargesIDChange = (result) => {
    let updateObject = {
      flywire_charges_id: result.value,
    };

    runUpdate(updateObject);
  };

  const referralRebateAmountShortUpdate = (result) => {
    let updateObject = {
      referral_rebate_amount_short: result.target.value,
    };

    runUpdate(updateObject);
  };

  const referralRebateAmountHalfUpdate = (result) => {
    let updateObject = {
      referral_rebate_amount_half: result.target.value,
    };

    runUpdate(updateObject);
  };

  const referralRebateAmountFullUpdate = (result) => {
    let updateObject = {
      referral_rebate_amount_full: result.target.value,
    };

    runUpdate(updateObject);
  };
  const referrerRebateAmountShortUpdate = (result) => {
    let updateObject = {
      referrer_rebate_amount_short: result.target.value,
    };

    runUpdate(updateObject);
  };

  const referrerRebateAmountHalfUpdate = (result) => {
    let updateObject = {
      referrer_rebate_amount_half: result.target.value,
    };

    runUpdate(updateObject);
  };

  const referrerRebateAmountFullUpdate = (result) => {
    let updateObject = {
      referrer_rebate_amount_full: result.target.value,
    };

    runUpdate(updateObject);
  };

  const agentBookingSourceChange = (result) => {
    let updateObject = {
      agent_booking_source_id: result.value,
    };

    runUpdate(updateObject);
  };

  const sharerBookingSourceChange = (result) => {
    let updateObject = {
      sharer_booking_source_id: result.value,
    };

    runUpdate(updateObject);
  };

  const agentSharerBookingSourceChange = (result) => {
    let updateObject = {
      agent_sharer_booking_source_id: result.value,
    };

    runUpdate(updateObject);
  };

  const sharerRequirementIdChange = (result) => {
    let updateObject = {
      sharer_requirement_id: result.value,
    };

    runUpdate(updateObject);
  };

  const agentGuardianBookingSourceChange = (result) => {
    let updateObject = {
      agent_guardian_booking_source_id: result.value,
    };

    runUpdate(updateObject);
  };

  const guardianBookingSourceChange = (result) => {
    let updateObject = {
      guardian_booking_source_id: result.value,
    };

    runUpdate(updateObject);
  };

  const resTypesSourceChange = (result) => {
    let updateObject = {
      res_types_source_id: result.value,
    };

    runUpdate(updateObject);
  };

  const saveNudgifyDetails = () => {};

  const runUpdate = (updateObject) => {
    Swal.fire({
      title: "Updating System Settings",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      showConfirmButton: false,
      willOpen: async () => {
        Swal.showLoading();
        await editSystemSettings(updateObject, authState ? authState.jwt : "")
          .then((response) => {
            Toast.fire({
              icon: "success",
              title: "Update Successful",
            });
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              titleText: "Error",
              text: "An Error has occured. Please try again.",
              allowOutsideClick: true,
              allowEscapeKey: true,
            });
          });
      },
    });
  };
  const onNudgifySubmit = (values) => {
    console.log(values);
    runUpdate(values);
  };

  const goPromoRules = () => {
    window.location.href = "/dashboard/promotion-rules";
  };

  const renderSystemSettings = () => {
    return (
      <div>
        <h2>
          Email Interval{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Sends Email to Agents every X hours if payment is not made)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {emailInterval && (
            <Select
              defaultValue={emailInterval}
              options={intervalOptions}
              onChange={emailIntervalChange}
            />
          )}
          {!emailInterval && <Loader />}
        </div>
        <h2>
          Expiry Duration{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Number of Days before Bank Transfer and Agent Reservations expire)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {expiryDuration && (
            <Select
              defaultValue={expiryDuration}
              options={expiryOptions}
              onChange={expiryDurationChange}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Agent Abandon Cart Email{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Email address to send agent abandon cart email notifications)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {agentAbandonCartEmail != null && (
            <TextField
              type="text"
              value={agentAbandonCartEmail.value}
              onChange={agentAbandonCartEmailOnchange}
              onBlur={agentAbandonCartEmailUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Set2 Rates Month{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Month when Set2 rates will be used instead of default rates)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {set2Month && (
            <Select
              value={set2Month}
              options={monthOptions}
              onChange={set2MonthChange}
              isClearable
              isMulti
            />
          )}
          {!set2Month && <Loader />}
        </div>
        <h2>
          Referral Rebate Amount Short Term{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Amount of rebate for referral code users for short term)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {referralRebateAmountShort != null && (
            <TextField
              type="number"
              value={referralRebateAmountShort.value}
              onChange={referralRebateAmountShortOnchange}
              onBlur={referralRebateAmountShortUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Referral Rebate Amount Half Lease{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Amount of rebate for referral code users for half lease)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {referralRebateAmountHalf != null && (
            <TextField
              type="number"
              value={referralRebateAmountHalf.value}
              onChange={referralRebateAmountHalfOnchange}
              onBlur={referralRebateAmountHalfUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Referral Rebate Amount Full Lease{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Amount of rebate for referral code users for full lease)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {referralRebateAmountFull != null && (
            <TextField
              type="number"
              value={referralRebateAmountFull.value}
              onChange={referralRebateAmountFullOnchange}
              onBlur={referralRebateAmountFullUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Referral Rebate Amount Short Term (Referrer){" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Amount of rebate for referral code users for short term)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {referrerRebateAmountShort != null && (
            <TextField
              type="number"
              value={referrerRebateAmountShort.value}
              onChange={referrerRebateAmountShortOnchange}
              onBlur={referrerRebateAmountShortUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Referral Rebate Amount Half Lease (Referrer){" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Amount of rebate for referral code users for half lease )
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {referrerRebateAmountHalf != null && (
            <TextField
              type="number"
              value={referrerRebateAmountHalf.value}
              onChange={referrerRebateAmountHalfOnchange}
              onBlur={referrerRebateAmountHalfUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Referral Rebate Amount Full Lease (Referrer){" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Amount of rebate for referral code users for full lease)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {referrerRebateAmountFull != null && (
            <TextField
              type="number"
              value={referrerRebateAmountFull.value}
              onChange={referrerRebateAmountFullOnchange}
              onBlur={referrerRebateAmountFullUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Office Bank Charges ID{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (ID for Sundry charges when making reciepts)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {sundryOptions && (
            <Select
              defaultValue={officeBankChargesID}
              options={sundryOptions}
              onChange={officeBankChargesIDChange}
            />
          )}
          {!sundryOptions && <Loader />}
        </div>
        <h2>
          Flywire Charges ID{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (ID for Sundry charges when making reciepts)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {sundryOptions && (
            <Select
              defaultValue={flywireChargesID}
              options={sundryOptions}
              onChange={flywireChargesIDChange}
            />
          )}
          {!sundryOptions && <Loader />}
        </div>
        <h2>
          Flywire Unsupported Countries{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Enter CountryCode:CountryName, eg AU:Australia, one per line)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {flywireUnsupportedCountries != null && (
            <TextField
              type="text"
              multiline
              rows={5}
              value={flywireUnsupportedCountries.value}
              onChange={flywireUnsupportedCountriesOnchange}
              onBlur={flywireUnsupportedCountriesUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Flywire Supported Countries{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Enter CountryCode:CountryName, eg AU:Australia, one per line)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {flywireSupportedCountries != null && (
            <TextField
              type="text"
              multiline
              rows={5}
              value={flywireSupportedCountries.value}
              onChange={flywireSupportedCountriesOnchange}
              onBlur={flywireSupportedCountriesUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Flywire Supported (With Fee) Countries{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Enter CountryCode:CountryName, eg AU:Australia, one per line)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {flywireSupportedCountriesWithFee != null && (
            <TextField
              type="text"
              multiline
              rows={5}
              value={flywireSupportedCountriesWithFee.value}
              onChange={flywireSupportedCountriesWithFeeOnchange}
              onBlur={flywireSupportedCountriesWithFeeUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <h2>
          Flywire Supported (With Invoice) Countries{" "}
          <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
            (Enter CountryCode:CountryName, eg AU:Australia, one per line)
          </span>
        </h2>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {flywireSupportedCountriesWithInvoice != null && (
            <TextField
              type="text"
              multiline
              rows={5}
              value={flywireSupportedCountriesWithInvoice.value}
              onChange={flywireSupportedCountriesWithInvoiceOnchange}
              onBlur={flywireSupportedCountriesWithInvoiceUpdate}
            />
          )}
          {!expiryDuration && <Loader />}
        </div>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Agent Booking Source ID{" "}
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Booking Source ID to attach to Reservations to identify it as an
              Agent Reservation)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            {bookingSourceOptions && (
              <Select
                defaultValue={agentBookingSource}
                options={bookingSourceOptions}
                onChange={agentBookingSourceChange}
              />
            )}
            {!bookingSourceOptions && <Loader />}
          </div>
        </form>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Additional Sharer Booking Source ID{" "}
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Booking Source ID to attach to Reservations to identify it as an
              Additional Sharer Reservation)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            {bookingSourceOptions && (
              <Select
                defaultValue={sharerBookingSource}
                options={bookingSourceOptions}
                onChange={sharerBookingSourceChange}
              />
            )}
            {!bookingSourceOptions && <Loader />}
          </div>
        </form>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Agent Additional Sharer Booking Source ID{" "}
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Booking Source ID to attach to Reservations to identify it as an
              Agent Additional Sharer Reservation)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            {bookingSourceOptions && (
              <Select
                defaultValue={agentSharerBookingSource}
                options={bookingSourceOptions}
                onChange={agentSharerBookingSourceChange}
              />
            )}
            {!bookingSourceOptions && <Loader />}
          </div>
        </form>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Additional Sharer Requirement ID{" "}
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Requirement ID to identify Additional Sharer Cost on RMS Cloud)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            {requirementOptions && (
              <Select
                defaultValue={sharerRequirementId}
                options={requirementOptions}
                onChange={sharerRequirementIdChange}
              />
            )}
            {!requirementOptions && <Loader />}
          </div>
        </form>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Agent Guardian Booking Source ID{" "}
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Booking Source ID to attach to Reservations to identify it as an
              Agent Guardian Reservation)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            {bookingSourceOptions && (
              <Select
                defaultValue={agentGuardianBookingSource}
                options={bookingSourceOptions}
                onChange={agentGuardianBookingSourceChange}
              />
            )}
            {!bookingSourceOptions && <Loader />}
          </div>
        </form>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Guardian Booking Source ID{" "}
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Booking Source ID to attach to Reservations to identify it as an
              Guardian Reservation)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            {bookingSourceOptions && (
              <Select
                defaultValue={guardianBookingSource}
                options={bookingSourceOptions}
                onChange={guardianBookingSourceChange}
              />
            )}
            {!bookingSourceOptions && <Loader />}
          </div>
        </form>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Booking Source Type (ResType)
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Booking Source Type to attach to Reservations, uses ResType field
              in RMS)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            {resTypesSourceOptions &&
              resTypesSourceOptions.map((e) => e.label).join(",")}
            {!resTypesSourceOptions && <Loader />}
            <br />
            <br />

            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={async () => {
                Swal.fire({
                  title: "Fetching ResType from RMS",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showCloseButton: false,
                  showConfirmButton: false,
                  willOpen: async () => {
                    Swal.showLoading();

                    try {
                      let data = await updateResTypes(
                        null,
                        authState ? authState.jwt : ""
                      );
                      console.log(data);
                      setResTypesSourceOptions(parseResTypes(data.data));
                      Toast.fire({
                        icon: "success",
                        title: "ResType updated successfully",
                      });
                    } catch (err) {
                      console.log(err);
                      Swal.fire({
                        icon: "error",
                        titleText: "Error",
                        text: "An Error has occured. Please try again.",
                        allowOutsideClick: true,
                        allowEscapeKey: true,
                      });
                    }
                  },
                });
              }}
            >
              Update Booking Source (ResType) Cache
            </Button>
          </div>
        </form>
        <form
          
          noValidate
          onSubmit={handleSubmit(onNudgifySubmit)}
        >
          <h2 style={{ marginBottom: 0 }}>
            Nudgify UUID & API Key
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Setup the UUID & API Keys to link purchases to Nudgify)
            </span>
          </h2>
          {!systemResponse.loading && (
            <div>
              <h3 style={{ marginBottom: 0 }}>English</h3>
              {(defaultUUIDEng || defaultUUIDEng == "") && (
                <TextField
                  name="nudgify_uuid_english"
                  margin="normal"
                  fullWidth
                  type="text"
                  label="UUID"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={defaultUUIDEng}
                  error={errors.nudgify_uuid_english != null}
                  helperText={
                    errors.nudgify_uuid_english != null
                      ? errors.nudgify_uuid_english.message
                      : null
                  }
                  //disabled={nudgifyResponse.loading}
                />
              )}
              {(defaultKeyEng || defaultKeyEng == "") && (
                <TextField
                  name="nudgify_key_english"
                  margin="normal"
                  fullWidth
                  label="API Key"
                  type="text"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={defaultKeyEng}
                  error={errors.nudgify_key_english != null}
                  helperText={
                    errors.nudgify_key_english != null
                      ? errors.nudgify_key_english.message
                      : null
                  }
                  //disabled={nudgifyResponse.loading}
                />
              )}
              <h3 style={{ marginBottom: 0 }}>Chinese</h3>
              {(defaultUUIDChi || defaultUUIDChi == "") && (
                <TextField
                  name="nudgify_uuid_chinese"
                  margin="normal"
                  fullWidth
                  type="text"
                  label="UUID"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={defaultUUIDChi}
                  error={errors.nudgify_uuid_chinese != null}
                  helperText={
                    errors.nudgify_uuid_chinese != null
                      ? errors.nudgify_uuid_chinese.message
                      : null
                  }
                  //disabled={nudgifyResponse.loading}
                />
              )}
              {(defaultKeyChi || defaultKeyChi == "") && (
                <TextField
                  name="nudgify_key_chinese"
                  margin="normal"
                  fullWidth
                  label="API Key"
                  type="text"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={defaultKeyChi}
                  error={errors.nudgify_key_chinese != null}
                  helperText={
                    errors.nudgify_key_chinese != null
                      ? errors.nudgify_key_chinese.message
                      : null
                  }
                  //disabled={nudgifyResponse.loading}
                />
              )}
              <div style={{ marginTop: 20, marginBottom: 20 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="small"
                >
                  Save Nudgify Details
                </Button>
              </div>
            </div>
          )}
        </form>
        <form  noValidate>
          <h2 style={{ marginBottom: 0 }}>
            Boot up Webhooks
            <span style={{ fontWeight: "normal", fontSize: 16, marginLeft: 5 }}>
              (Initialize Webhooks in the case it is not created on server
              boot-up)
            </span>
          </h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={async () => {
                Swal.fire({
                  title: "Initializing Webhook",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showCloseButton: false,
                  showConfirmButton: false,
                  willOpen: async () => {
                    Swal.showLoading();

                    try {
                      let response = await initializeWebhooks(authState.jwt);
                      if (response.data == "success") {
                        Toast.fire({
                          icon: "success",
                          title: "Initialize Successful",
                        });
                      }
                    } catch (err) {
                      console.log(err);
                      Swal.fire({
                        icon: "error",
                        titleText: "Error",
                        text: "An Error has occured. Please try again.",
                        allowOutsideClick: true,
                        allowEscapeKey: true,
                      });
                    }
                  },
                });
              }}
            >
              Initialize Webhooks
            </Button>
          </div>
          <h2 style={{ marginBottom: 0 }}>Refresh Availability Cache</h2>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={refreshCache.bind(null, false)}
            >
              Refresh Availability Cache
            </Button>
          </div>
          <hr />
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={goPromoRules}
            >
              View/Edit Promotion Exclusion Rules
            </Button>
          </div>
        </form>
      </div>
    );
  };

  return (
    <ListPageShell>
      <ListPageCard sx={{ mt: 2.5 }}>
        <ListPageHeader title="System Settings" />
        {renderSystemSettings()}
      </ListPageCard>
      {/* <ListPageCard >
        <div>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              initWebhook();
            }}
          >
            Setup Webhook
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              getWebhookRequest();
            }}
          >
            Get Webhook
          </Button>
        </div>
      </ListPageCard> */}
    </ListPageShell>
  );
};

export default SystemSettings;
